/*
 * env 环境
 * develop 测试环境
 * master 正式环境
 * 或者使用 process.env.NODE_ENV ，配置自动发布时使用
 */
//develop 测试环境，master 正式环境
const env="master";
export default env;



// WEBPACK FOOTER //
// ./src/config/env.modal.js